import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-windows",
  "use": "icon-windows-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-windows\"><defs><style type=\"text/css\"></style></defs><path d=\"M125.578 242.306v221.827l243.037-9.090v-263.231l-243.037 50.489zM470.948 163.537v286.463l428.852-15.821v-359.678l-428.852 89.037zM125.578 560.077v221.827l243.037 50.494v-263.232l-243.037-9.089zM470.948 574.211v286.463l428.852 89.037v-359.678l-428.852-15.821z\" p-id=\"2292\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol